import { createSlice } from "@reduxjs/toolkit";
import { loadCustomers } from "./actions";
import { Customer } from "services/customer/types";

/**
 * Initial state.
 */
const initialState: Customer[] = [];

/**
 * Customers entity adapter slice.
 */
const customersSlice = createSlice({
  name: "customers",
  initialState: initialState,
  reducers: {
    resetCustomers(state) {
      state = initialState;

      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadCustomers.fulfilled, (state, action) => {
      if (action.payload.isSuccessful) {
        return action.payload.data ?? [];
      }

      return [];
    });
  },
});

export const { resetCustomers } = customersSlice.actions;

export default customersSlice.reducer;
